const resources = {
    representative: 'Des représentant(e)s sont disponibles :',
    monSunTime: 'de 5 h à 21 h HP',
    monSun: 'Du lundi au dimanche',
    chatWithUs: 'Clavardez avec nous'
};

module.exports = function getResource(label) {
    return resources[label];
};
